import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.user.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-component-user-home',
template: templateSource || '',
    styles: [``],
})
export class ComponentUserHomeComponent implements OnInit {
    public machineCount: number | null = null;
    public totalQuantity: number | null = null;
    public totalWeight: number | null = null;
    public totalPlate: number | null = null;

    public gradeLog: any[] = [];
    public productChart: any = null;

    public eggprice: any = null;
    public statisticChart: any = null;
    public efficiencyChart: any = null;
    public farmId: string = '';
    public communicationData: any = { machine: false, env: false };

    private gradeMap = '왕란,특란,대란,중란,소란,경란,파란,혈란,오란,등외'.split(',');

    constructor(@Inject( Service)         public service: Service,@Inject( Title    )         private title: Title    ) { }

    async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow(true, "/auth/login");
        if (!allowed) return;
        this.title.setTitle('에그텍스마트플랫폼 사용자 페이지');
        await this.load();
    }

    private async load() {
        const [statisticRes, eggPriceRes, statusRes] = await Promise.all([
            wiz.call('statistic'),
            wiz.call('eggprice'),
            wiz.call('status')
        ]);

        this.applyStatistic(statisticRes);
        this.applyEggPrice(eggPriceRes);

        if (!this.farmId && statusRes?.code === 200 && statusRes.data) {
            this.farmId = statusRes.data.farm_id || '';
        }
        this.applyCharts(statusRes);

        await this.service.render();
    }

    private applyStatistic(response: any) {
        const { code, data } = response || {};
        if (code !== 200) return;

        if (data.farm_id) {
            this.farmId = data.farm_id;
        }

        this.machineCount = data.machines ?? 0;
        this.gradeLog = data.log ?? [];

        let quantity = 0;
        let weight = 0;
        let plate = 0;
        for (const item of this.gradeLog) {
            quantity += Number(item?.quantity ?? 0);
            weight += Number(item?.weight ?? 0);
            plate += Number(item?.plate ?? 0);
        }

        this.totalQuantity = quantity;
        this.totalWeight = weight;
        this.totalPlate = plate;

        // 생산 현황을 선 그래프 형식으로 변환
        const labels: string[] = [];
        const values: number[] = [];

        for (const item of this.gradeLog) {
            const grade = item.grade ? this.gradeMap[(item.grade - 1)] || `등급${item.grade}` : '';
            labels.push(grade);
            values.push(item.quantity || 0);
        }

        if (labels.length > 0) {
            this.productChart = {
                title: '등급별 생산수량',
                labels,
                datasets: [{
                    label: '생산수량',
                    data: values,
                    fill: true,
                    backgroundColor: 'rgba(246,146,50,0.1)',
                    borderColor: '#f69232',
                    tension: 0.3,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    pointBackgroundColor: '#f69232'
                }]
            };
        }
    }

    private applyEggPrice(chartres: any) {
        if (!chartres || chartres.code !== 200) return;

        const datasets = [
            {
                label: '왕란',
                data: [],
                fill: false,
                borderColor: '#f69232',
                tension: 0.3,
                pointRadius: 0
            },
            {
                label: '특란',
                data: [],
                fill: false,
                borderColor: '#8b5cf6',
                tension: 0.3,
                pointRadius: 0
            },
            {
                label: '대란',
                data: [],
                fill: false,
                borderColor: '#38bdf8',
                tension: 0.3,
                pointRadius: 0
            },
            {
                label: '중란',
                data: [],
                fill: false,
                borderColor: '#10b981',
                tension: 0.3,
                pointRadius: 0
            }
        ];

        const labels: string[] = [];

        chartres.data.forEach((item: any) => {
            const d = item.date;
            labels.push(typeof d === 'string' ? d.substring(0, 10) : String(d));
            datasets[0].data.push(item.egg1 ?? null);
            datasets[1].data.push(item.egg2 ?? null);
            datasets[2].data.push(item.egg3 ?? null);
            datasets[3].data.push(item.egg4 ?? null);
        });

        this.eggprice = {
            title: '계란시세 (원/30개)',
            link: '/user/monitoring/eggprice',
            linkText: '더보기',
            labels,
            datasets
        };
    }

    private applyCharts(response: any) {
        if (!response || response.code !== 200 || !response.data) return;

        const res = response.data;
        const farmId = this.farmId;

        const dailyReport: Record<string, any> = {};

        for (const item of (res.supply || [])) {
            const day = String(item.date || '').substring(0, 10);
            if (!day) continue;
            if (!dailyReport[day]) dailyReport[day] = {};
            dailyReport[day].water = item.water || 0;
            dailyReport[day].feed = item.feed || 0;
            dailyReport[day].feed_price = item.feed_price || 0;
        }

        for (const item of (res.eggproduct || [])) {
            const day = String(item.date || '').substring(0, 10);
            if (!day) continue;
            if (!dailyReport[day]) dailyReport[day] = {};
            dailyReport[day].eggproduct = item.weight || 0;
        }

        for (const item of (res.eggprice || [])) {
            const day = String(item.date || '').substring(0, 10);
            if (!day) continue;
            const avgPrice = ((item.egg1 || 0) + (item.egg2 || 0) + (item.egg3 || 0) + (item.egg4 || 0)) / 4;
            if (!dailyReport[day]) dailyReport[day] = {};
            dailyReport[day].eggprice = avgPrice;
        }

        const labels: string[] = [];
        const nValues: number[] = [];
        const sValues: number[] = [];
        const pValues: number[] = [];
        const fValues: number[] = [];

        const now = new Date();
        const target = new Date();
        target.setMonth(target.getMonth() - 1);

        while (target.getTime() < now.getTime()) {
            const day = target.toISOString().substring(0, 10);
            const item = dailyReport[day] || {};

            const feed = item.feed || 0;
            let feedPrice = item.feed_price || 0;
            const eggPrice = item.eggprice || 0;
            const water = item.water || 0;
            const eggproduct = item.eggproduct || 0;

            if (feedPrice === 0) feedPrice = 600;

            labels.push(day);

            nValues.push(eggPrice / feedPrice);
            sValues.push(feed > 0 ? water / feed : 0);

            pValues.push(feed > 0 ? eggproduct / feed : 0);
            fValues.push(eggproduct > 0 ? feed / eggproduct : 0);

            target.setDate(target.getDate() + 1);
        }

        this.statisticChart = {
            title: '난사비·수사비',
            description: '* 난사비·수사비를 확인하려면 농장관리-계사정보에 일별 급이량/급수량을 등록해주세요.',
            link: farmId ? `/user/farm/dashboard/${farmId}` : '',
            linkText: '농장관리',
            labels,
            datasets: [
                {
                    label: '난사비',
                    data: nValues,
                    fill: false,
                    pointRadius: 0,
                    borderWidth: 2,
                    borderColor: '#f69232',
                    tension: 0.3
                },
                {
                    label: '수사비',
                    data: sValues,
                    fill: false,
                    pointRadius: 0,
                    borderWidth: 2,
                    borderColor: '#8b5cf6',
                    tension: 0.3
                }
            ]
        };

        this.efficiencyChart = {
            title: '생산효율·사료요구율',
            description: '* 생산효율·사료요구율을 확인하려면 농장관리-계사정보에 일별 급이량을 등록해주세요.',
            link: farmId ? `/user/farm/dashboard/${farmId}` : '',
            linkText: '농장관리',
            labels,
            datasets: [
                {
                    label: '생산효율',
                    data: pValues,
                    fill: false,
                    pointRadius: 0,
                    borderWidth: 2,
                    borderColor: '#38bdf8',
                    tension: 0.3
                },
                {
                    label: '사료요구율',
                    data: fValues,
                    fill: false,
                    pointRadius: 0,
                    borderWidth: 2,
                    borderColor: '#10b981',
                    tension: 0.3
                }
            ]
        };
    }
}

export default ComponentUserHomeComponent;